import downArrowIcon from '../../media/simple-mono-icons/arrow-down.svg';

function PillDropdown(props) {
    let sizeClasses = '';

    switch(props.size || 'md') {
        case 'sm':
            sizeClasses = 'px-4 py-2 text-sm';
            break;
        case 'md':
            sizeClasses = 'px-7 py-3';
            break;
        case 'lg':
            sizeClasses = 'px-10 py-4';
            break;
        default:
            sizeClasses = 'px-7 py-3';
            break;
    }

    // TODO: add a dropdown menu to this component
    // TODO: add state

    return (
        <button className={`flex rounded-full ${sizeClasses} text-dark-grey border-solid border-2 border-grey bg-white hover:bg-light-grey focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-logo-green transition-color text-bold pointer-events-auto`} onClick={props.onClick}>
            {props.children}
            <img src={downArrowIcon} className="ml-2"></img>
        </button>
    );
}

export default PillDropdown;